import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RatingRoutingModule } from './rating-routing.module';
import { RatingComponent } from './rating.component';
import { ExteriorComponent } from './exterior/exterior.component';
import { InteriorComponent } from './interior/interior.component';
import { MechanicsComponent } from './mechanics/mechanics.component';
import { FrameComponent } from './frame/frame.component';
import { MajorOptionsComponent } from './major-options/major-options.component';
import { GradingComponent } from './grading/grading.component';
import { RepairCostComponent } from './repair-cost/repair-cost.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { TranslateModule } from '@ngx-translate/core';
import { CommonCompModule } from 'src/app/common/common-comp.module';

import { NgxMaskModule } from 'ngx-mask';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxImageCompressService } from 'ngx-image-compress';
import { NgxDropzoneModule } from 'ngx-dropzone';

@NgModule({
  declarations: [
    RatingComponent,
    ExteriorComponent,
    InteriorComponent,
    MechanicsComponent,
    FrameComponent,
    MajorOptionsComponent,
    GradingComponent,
    RepairCostComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RatingRoutingModule,
    ComponentsModule,
    CommonCompModule,
    NgSelectModule,
    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    TooltipModule.forRoot(),
    NgxMaskModule.forRoot(),
    NgxDropzoneModule,
    TranslateModule.forChild({
      extend: true,
    }),
  ],
  exports: [
    InteriorComponent,
    MechanicsComponent,
    FrameComponent,
    MajorOptionsComponent,
  ],
  providers: [NgxImageCompressService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RatingModule {}
